import {
  FiDownload,
  FiPackage,
  FiArchive,
  FiShoppingCart,
  FiTruck,
  FiUsers,
  FiUserCheck,
  FiFileText,
  FiBarChart2,
} from "react-icons/fi";

const exportsData = [
  {
    title: "Products",
    description: "Export products and variants",
    icon: FiPackage,
    records: "12,458 Records",
  },
  {
    title: "Inventory",
    description: "Export stock availability",
    icon: FiArchive,
    records: "52,340 Units",
  },
  {
    title: "Sales",
    description: "Export invoices and orders",
    icon: FiShoppingCart,
    records: "24,560 Orders",
  },
  {
    title: "Purchases",
    description: "Export PO and GRN data",
    icon: FiTruck,
    records: "4,215 Records",
  },
  {
    title: "Customers",
    description: "Export customer database",
    icon: FiUsers,
    records: "8,245 Customers",
  },
  {
    title: "Employees",
    description: "Export employee records",
    icon: FiUserCheck,
    records: "145 Employees",
  },
  {
    title: "GST Reports",
    description: "Export GST filing reports",
    icon: FiFileText,
    records: "Monthly Reports",
  },
  {
    title: "Stock Valuation",
    description: "Export inventory valuation",
    icon: FiBarChart2,
    records: "Current Inventory",
  },
];

export default function ExportCenterPage() {
  return (
    <div>
      {/* HEADER */}

      <div className="mb-8">
        <p className="text-sm text-gray-500">
          Tools / Export Center
        </p>

        <h1 className="text-3xl font-bold mt-1">
          Export Center
        </h1>

        <p className="text-gray-500 mt-2">
          Download ERP data in Excel, CSV and PDF formats.
        </p>
      </div>

      {/* STATS */}

      <div className="grid md:grid-cols-4 gap-5 mb-8">
        <StatCard
          title="Exports Today"
          value="18"
        />

        <StatCard
          title="Records Exported"
          value="85,420"
        />

        <StatCard
          title="Scheduled Reports"
          value="12"
        />

        <StatCard
          title="Last Export"
          value="15 Min Ago"
        />
      </div>

      {/* EXPORT MODULES */}

      <div className="grid md:grid-cols-2 xl:grid-cols-4 gap-6">
        {exportsData.map((item) => {
          const Icon = item.icon;

          return (
            <div
              key={item.title}
              className="
                bg-white
                border
                border-gray-100
                rounded-3xl
                p-6
                hover:shadow-xl
                transition-all
              "
            >
              <div
                className="
                  h-14
                  w-14
                  rounded-2xl
                  bg-green-50
                  text-green-600
                  flex
                  items-center
                  justify-center
                "
              >
                <Icon size={24} />
              </div>

              <h3 className="font-bold text-lg mt-5">
                {item.title}
              </h3>

              <p className="text-sm text-gray-500 mt-2">
                {item.description}
              </p>

              <p className="text-xs text-gray-400 mt-3">
                {item.records}
              </p>

              <button
                className="
                  mt-6
                  w-full
                  h-11
                  rounded-xl
                  bg-primary-700
                  text-white
                  flex
                  items-center
                  justify-center
                  gap-2
                  font-medium
                "
              >
                <FiDownload />
                Export
              </button>
            </div>
          );
        })}
      </div>

      {/* RECENT EXPORTS */}

      <div className="mt-8 bg-white border border-gray-100 rounded-3xl overflow-hidden">
        <div className="p-6 border-b border-gray-100">
          <h2 className="font-semibold text-lg">
            Recent Exports
          </h2>
        </div>

        <table className="w-full">
          <thead>
            <tr className="bg-gray-50">
              <th className="px-6 py-4 text-left">
                File
              </th>

              <th className="px-6 py-4 text-left">
                Module
              </th>

              <th className="px-6 py-4 text-left">
                Exported By
              </th>

              <th className="px-6 py-4 text-left">
                Date
              </th>

              <th className="px-6 py-4 text-center">
                Format
              </th>

              <th className="px-6 py-4 text-center">
                Records
              </th>
            </tr>
          </thead>

          <tbody>
            {[
              {
                file: "products.xlsx",
                module: "Products",
                user: "Admin",
                date: "Today",
                format: "Excel",
                records: 12458,
              },
              {
                file: "inventory.xlsx",
                module: "Inventory",
                user: "Manager",
                date: "Today",
                format: "Excel",
                records: 52340,
              },
              {
                file: "sales-june.pdf",
                module: "Sales",
                user: "Admin",
                date: "Yesterday",
                format: "PDF",
                records: 4210,
              },
            ].map((row) => (
              <tr
                key={row.file}
                className="border-t border-gray-100"
              >
                <td className="px-6 py-4">
                  {row.file}
                </td>

                <td className="px-6 py-4">
                  {row.module}
                </td>

                <td className="px-6 py-4">
                  {row.user}
                </td>

                <td className="px-6 py-4">
                  {row.date}
                </td>

                <td className="px-6 py-4 text-center">
                  <span className="px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-semibold">
                    {row.format}
                  </span>
                </td>

                <td className="px-6 py-4 text-center">
                  {row.records.toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* QUICK EXPORTS */}

      <div className="mt-8 bg-white border border-gray-100 rounded-3xl p-6">
        <h2 className="font-semibold text-lg mb-5">
          Quick Exports
        </h2>

        <div className="grid md:grid-cols-4 gap-4">
          <button className="h-12 rounded-xl bg-gray-100 font-medium">
            Today's Sales
          </button>

          <button className="h-12 rounded-xl bg-gray-100 font-medium">
            Current Inventory
          </button>

          <button className="h-12 rounded-xl bg-gray-100 font-medium">
            Low Stock Report
          </button>

          <button className="h-12 rounded-xl bg-gray-100 font-medium">
            Purchase Summary
          </button>
        </div>
      </div>
    </div>
  );
}

function StatCard({ title, value }) {
  return (
    <div className="bg-white border border-gray-100 rounded-3xl p-6">
      <p className="text-sm text-gray-500">
        {title}
      </p>

      <h3 className="text-3xl font-bold mt-2">
        {value}
      </h3>
    </div>
  );
}